module.exports = __webpack_public_path__ + "img/成果展示banner.389cd690.png";